import InfoBanner, { Variants } from '@root/core/src/components/info-banner';
import Link from '@root/core/src/components/link';
import Modal from '@root/core/src/components/modal';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import TimeDelayInfo from '@root/quotes/src/components/time-delay-info';
import { StyleSheet } from '@root/core/src/utils/styles';
import { useState } from '@root/vendor/react';

export default function CoverageRestrictedBanner({
  coverageNames,
  estimatedCompletionDate,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOnModalClose = () => {
    setIsModalOpen(false);
  };

  const coverageString = coverageNames.length > 1 ?
    coverageNames.join(' & ').concat(' coverages are') :
    coverageNames[0].concat(' coverage is');

  const bannerText = (
    <div>
      {coverageString} unavailable for purchase at this time. <br />
      <Link
        css={styles.textButton}
        onClick={() => setIsModalOpen(true)}
      >
        Learn more
      </Link>
    </div>
  );

  return (
    <div css={styles.outer}>
      <InfoBanner
        text={bannerText}
        variant={Variants.WARNING}
      />

      <Modal
        isShowing={isModalOpen}
        name={'time-delay-info-modal'}
        onCancel={handleOnModalClose}
        responsiveCloseButton={true}
        styleOverrides={styleOverrides}
      >
        <TimeDelayInfo
          estimatedCompletionDate={estimatedCompletionDate}
          onCloseModal={handleOnModalClose}
        />
      </Modal>
    </div>
  );
}

const styles = StyleSheet.create({
  outer: {
    marginBottom: '20px',
    maxWidth: 550,
  },
});

const styleOverrides = StyleSheet.create({
  innerContent: {
    ...Responsive.sm({
      padding: 40,
    }),
  },
});

CoverageRestrictedBanner.propTypes = {
  coverageNames: PropTypes.array.isRequired,
  estimatedCompletionDate: PropTypes.string.isRequired,
};
